<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">

<div class="content" [formGroup]="form">
    <p class="yes-or-no">
        <span #yes_or_no_area>
            <div class="circle">
                <a class="like yes_or_no" id="yes" (mouseover)="hoverColor('yes')" (mouseout)="outColor('yes')" [ngStyle]="{'color': objColor['background-color']}" (click)="setFormValue('sim'); clickColor('yes');">1</a>
            </div>
            <div class="circle">
                <a class="deslike yes_or_no" id="no" (mouseover)="hoverColor('no')" (mouseout)="outColor('no')" [ngStyle]="{'color': objColor['background-color']}" (click)="setFormValue('não'); clickColor('no');">2</a>
            </div>
        </span>
    </p>
    <div class="score-area">
        <p class="high-score-yes">{{high_score_label}}</p>
        <p class="low-score-no">{{low_score_label}}</p>
    </div>
</div>

